module.exports = __webpack_public_path__ + "static/media/WL.1bdf16e9.mp4";